import { PlayerEvent, type PlayerInterface, type TextTrack } from '@foundation-player/loader';
import { readonly, writable, type Readable, type Writable } from 'svelte/store';
import type { PlayerStoreModule } from './player-store-types';

export class TextTrackPlayerStore implements PlayerStoreModule<'activeTextTrack' | 'availableTextTracks'> {
  readonly #activeTextTrack: Writable<TextTrack | undefined> = writable(undefined);
  readonly activeTextTrack: Readable<TextTrack | undefined> = readonly(this.#activeTextTrack);

  readonly #availableTextTracks: Writable<TextTrack[]> = writable([]);
  readonly availableTextTracks: Readable<TextTrack[]> = readonly(this.#availableTextTracks);

  initializeStateFromPlayer(player: PlayerInterface) {
    player.addEventListener(PlayerEvent.Ready, () => {
      this.#syncStateFromPlayer(player);
    });

    player.addEventListener(PlayerEvent.ContentStart, () => {
      this.#syncStateFromPlayer(player);
    });

    player.addEventListener(PlayerEvent.TextTrackSelected, () => {
      this.#syncActiveTextTrackFromPlayer(player);
    });

    this.#syncStateFromPlayer(player);
  }

  #syncStateFromPlayer(player: PlayerInterface) {
    this.#syncAvailableTextTracksFromPlayer(player);
    this.#syncActiveTextTrackFromPlayer(player);
  }

  #syncAvailableTextTracksFromPlayer(player: PlayerInterface) {
    this.#availableTextTracks.set(player.getTextTracks());
  }

  #syncActiveTextTrackFromPlayer(player: PlayerInterface) {
    // instead of checking if the current or emitted text track is active, we
    // can just request the active text track, as this will return `undefined`
    // if there is no active text track
    this.#activeTextTrack.set(player.getActiveTextTrack());
  }
}
